'use client';

import {
	Card, SimpleGrid, GridItem, createListCollection,
} from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import React from 'react';

import { AppRoutes } from '@/constants/route';
import { NextLinkWrapper } from '@/modules/navigation/presentation';
import type { ContactUsFormModel } from  '@/modules/static/view-model';

import { Form } from '@packages/hook-form-wrapper';

export const ContactUsForm = () => {
	const t = useTranslations('contactForm');
	const contactReasonCollection = createListCollection({
		items: [
			{
				label: t('fields.reason.options.login'),
				value: 'login',
			},
			{
				label: t('fields.reason.options.siteUsage'),
				value: 'siteUsage',
			},
			{
				label: t('fields.reason.options.membershipCancel'),
				value: 'membershipCancel',
			},
			{
				label: t('fields.reason.options.noContactFromCompany'),
				value: 'noContactFromCompany',
			},
			{
				label: t('fields.reason.options.jobMismatch'),
				value: 'jobMismatch',
			},
			{
				label: t('fields.reason.options.inappropriateTreatment'),
				value: 'inappropriateTreatment',
			},
			{
				label: t('fields.reason.options.inappropriateScout'),
				value: 'inappropriateScout',
			},
			{
				label: t('fields.reason.options.bugReport'),
				value: 'bugReport',
			},
			{
				label: t('fields.reason.options.other'),
				value: 'other',
			},
		],
	});

	return (
		<Card.Root>
			<Card.Header bg="gray.10" p={4}>
				<Card.Title color="primary.100" textAlign="center" textStyle="h3">
					{t('title')}
				</Card.Title>
			</Card.Header>
			<Card.Body>
				<SimpleGrid columns={2} gap="sm">
					<GridItem colSpan={2}>
						<Form.SelectInput<ContactUsFormModel>
							collection={contactReasonCollection}
							label={t('fields.reason.label')}
							name="reason"
							placeholder={t('fields.reason.placeholder')}
						/>
					</GridItem>
					<GridItem>
						<Form.TextInput<ContactUsFormModel>
							label={t('fields.firstName.label')}
							name="firstName"
							placeholder={t('fields.firstName.placeholder')}
						/>
					</GridItem>
					<GridItem>
						<Form.TextInput<ContactUsFormModel>
							label={t('fields.lastName.label')}
							name="lastName"
							placeholder={t('fields.lastName.placeholder')}
						/>
					</GridItem>
					<GridItem colSpan={2}>
						<Form.TextInput<ContactUsFormModel>
							label={t('fields.email.label')}
							name="email"
							placeholder={t('fields.email.placeholder')}
						/>
					</GridItem>
					<GridItem colSpan={2}>
						<Form.TextAreaInput<ContactUsFormModel>
							label={t('fields.message.label')}
							minH="150px"
							name="message"
							placeholder={t('fields.message.placeholder')}
						/>
					</GridItem>
					<GridItem colSpan={2} mt={-4}>
						<Form.Checkbox<ContactUsFormModel> name="consent">
							{t.rich('fields.content', {
								link: children => (
									<NextLinkWrapper
										color="primary.100"
										href={AppRoutes.static.privacyPolicy}
										isNewTab
									>
										{children}
									</NextLinkWrapper>
								),
							})}
						</Form.Checkbox>
					</GridItem>
				</SimpleGrid>
			</Card.Body>
			<Card.Footer>
				<Form.SubmitButton mx="auto">
					{t('submit')}
				</Form.SubmitButton>
			</Card.Footer>
		</Card.Root>
	);
};
